import React from "react";
import {
	MDBCarousel,
	MDBCarouselInner,
	MDBCarouselItem,
	MDBIcon,
	MDBRow,
	MDBCol,
	MDBBtn,
} from "mdbreact";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

export default function CarouselCampanha2022(props) {
	const responsive = {
		desktop: {
			breakpoint: { max: 3000, min: 1025 },
			items: 1,
			slidesToSlide: 1, // optional, default to 1.
		},
		tablet: {
			breakpoint: { max: 1024, min: 465 },
			items: 1,
			slidesToSlide: 1, // optional, default to 1.
		},
		mobile: {
			breakpoint: { max: 464, min: 0 },
			items: 1,
			slidesToSlide: 1, // optional, default to 1.
		},
	};

	// Define os botões de avanço e retorno do carousel
	const ButtonGroup = ({ next, previous, ...rest }) => {
		const {
			carouselState: { currentSlide },
		} = rest;

		return (
			<>
				<MDBRow
					style={{
						position: "absolute",
						top: "0%",
						left: "50%",
						transform: "translateX(-42%)",
					}}
				>
					<MDBCol className="d-flex p-0 pr-2">
						<MDBBtn
							outline
							color={"primary"}
							className="arrow-carrousel m-0"
							onClick={() => previous()}
						>
							<span className="d-flex">
								<MDBIcon icon="chevron-left" className="p-1" />
							</span>
						</MDBBtn>
					</MDBCol>
					<MDBCol className="d-flex p-0 pl-2">
						<MDBBtn
							outline
							color={"primary"}
							className="arrow-carrousel m-0"
							onClick={() => next()}
						>
							<span className="d-flex">
								<MDBIcon icon="chevron-right" className="p-1" />
							</span>
						</MDBBtn>
					</MDBCol>
				</MDBRow>
			</>
		);
	};

	return (
		<>
			<Carousel
				swipeable={true}
				draggable={false}
				showDots={true}
				responsive={responsive}
				ssr={true} // means to render carousel on server-side.
				infinite={true}
				autoPlay={props.deviceType !== "mobile" ? true : false}
				autoPlaySpeed={3000}
				keyBoardControl={true}
				transitionDuration={500}
				arrows={false}
				renderButtonGroupOutside={true}
				customButtonGroup={<ButtonGroup />}
				containerClass="carousel-container pb-4"
				className="pt-5 mt-3"
			>
				{["https://www.youtube.com/embed/jSBFW4FoLdM"].map((i, index) => {
					return (
						<>
							<iframe
								width="320"
								height="100%"
								src={i}
								title="Vestibular Feevale 2022/01"
								frameborder="0"
								allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
								allowfullscreen
								className="text-center"
							></iframe>
						</>
					);
				})}
			</Carousel>
		</>
	);
}
